export {FoldingHeading} from './FoldingHeading';
